import strFunc from "@/lib/lyg/string";
import DateFunc from '@/lib/lyg/date_func';
import TextAreaComponent from "@/pcomponents/common/crud/write/textarea";
import AttendStateFunc from "@/pcomponents/common/content/edu/attend/func/state_func";

function DailyInputText(props: any) {
  let myProps = {
    Style: {},
    info: {},
    daily_info: {},
    name: "",
    is_checked_row: false,
    is_check_show_textarea: false,
    onChange: (inData: any) => { },
    onClick: (inData: any) => { },
    onBlur: (inData: any) => { },
    onClickLeft: (inData: any) => { },
    is_print_mode: false,
    ...props
  };
  let Style = myProps.Style;
  let info = myProps.info;
  let name = myProps.name;
  let value = myProps.daily_info[name] ? myProps.daily_info[name] : "";

  //선택
  let select_input_render: any = "";
  let select_tag_of_num_style: any = {
    width: "16px", position: "absolute", left: -1, top: -1, textAlign: "center", paddingLeft: 2,
    border: "1px solid #555"
  };
  if (myProps.is_print_mode) {
    select_tag_of_num_style["border"] = "1px solid #888";
  }
  let textbook_info: any = null;
  if (name == "a_textbook_study" || name == "a_textbook_study_det") {
    if (myProps.info["daily_textbook_arr"] && myProps.info["daily_textbook_arr"].length > 0) {
      for (let i = 0; i < myProps.info["daily_textbook_arr"].length; i++) {
        if (myProps.info["daily_textbook_arr"][i]["a_seq"] == myProps.daily_info["a_textbook_seq"]) {
          textbook_info = myProps.info["daily_textbook_arr"][i];
        }
      }
    }
    if (myProps.info["daily_study_title_arr"] && myProps.info["daily_study_title_arr"].length > 0) {
      for (let i = 0; i < myProps.info["daily_study_title_arr"].length; i++) {
        if (myProps.info["daily_study_title_arr"][i]["a_seq"] == myProps.daily_info["a_textbook_seq"]) {
          textbook_info = myProps.info["daily_study_title_arr"][i];
        }
      }
    }

    let is_add_select_input = false;
    if (textbook_info != null) {
      is_add_select_input = true;
      if (textbook_info["a_use_sort"] == "coolen") {
        is_add_select_input = false;
      }
    }
    if (is_add_select_input) {
      if (name == "a_textbook_study") {
        let select_title_str = "";
        for (let i = 0; i < textbook_info.section_arr.length; i++) {
          let idx_num = i + 1;
          select_title_str += idx_num + ". " + textbook_info.section_arr[i]["a_title"] + "\n";
        }

        select_input_render = (
          <select
            className="select_none_arrow"
            value={myProps.daily_info["a_textbook_study_num"]}
            onChange={(e: any) => {
              let change_row_data: any = {};
              let change_val = parseInt(strFunc.uncomma(e.target.value));
              change_val--;
              if (change_val >= 0 && change_val < textbook_info.section_arr.length) {
                change_row_data["a_textbook_study"] = textbook_info.section_arr[change_val]["a_title"];
                change_row_data["a_textbook_section_seq"] = textbook_info.section_arr[change_val]["a_seq"];
                change_row_data["a_textbook_study_det"] = "";
                change_row_data["a_textbook_study_det_num"] = "";
                change_row_data["a_textbook_detail_seq"] = "";
              }

              myProps.onChange({
                name: "a_textbook_study_num",
                value: e.target.value,
                change_row_data: change_row_data,
                is_save: true,
              });
            }}
            title={select_title_str}
            style={select_tag_of_num_style}
          >
            <option value=""></option>
            {textbook_info.section_arr &&
              textbook_info.section_arr.map((item: any, idx: number) => {
                let tmp_option_idx = idx + 1;
                let tmp_option_text = " " + tmp_option_idx + " " + item["a_title"];
                return (<option key={idx} value={tmp_option_idx}>{tmp_option_text}</option>)
              })
            }
          </select>
        );
      } else if (name == "a_textbook_study_det") {
        let row_study_arr: any = [];
        let row_select_section = null;
        let a_textbook_study_num = parseInt(strFunc.uncomma(myProps.daily_info["a_textbook_study_num"]));
        a_textbook_study_num--;
        if (a_textbook_study_num >= 0 && a_textbook_study_num < textbook_info.section_arr.length) {
          row_select_section = textbook_info.section_arr[a_textbook_study_num];
          for (let i = 0; i < textbook_info.study_arr.length; i++) {
            if (textbook_info.study_arr[i]["a_section_seq"] == row_select_section["a_seq"]) {
              row_study_arr.push(textbook_info.study_arr[i]);
            }
          }
        }

        let select_title_str = "";
        for (let i = 0; i < row_study_arr.length; i++) {
          let idx_num = i + 1;
          select_title_str += idx_num + ") " + row_study_arr[i]["a_title"] + "\n";
        }

        select_input_render = (
          <select
            className="select_none_arrow"
            value={myProps.daily_info["a_textbook_study_det_num"]}
            onChange={(e: any) => {
              let change_row_data: any = {};
              let change_val = parseInt(strFunc.uncomma(e.target.value));
              change_val--;
              if (change_val >= 0 && change_val < row_study_arr.length) {
                change_row_data["a_textbook_study_det"] = row_study_arr[change_val]["a_title"];
                change_row_data["a_textbook_detail_seq"] = row_study_arr[change_val]["a_seq"];
              }

              myProps.onChange({
                name: "a_textbook_study_det_num",
                value: e.target.value,
                change_row_data: change_row_data,
                is_save: true,
              });
            }}
            title={select_title_str}
            style={select_tag_of_num_style} >
            <option value=""></option>
            {row_study_arr &&
              row_study_arr.map((item: any, idx: number) => {
                let tmp_option_idx = idx + 1;
                let tmp_option_text = " " + tmp_option_idx + " " + item["a_title"];
                return (<option key={idx} value={tmp_option_idx}>{tmp_option_text}</option>)
              })
            }
          </select>
        );
      }
    }
  }
  if (name == "a_subtextbook" || name == "a_homework") {
    let pre_sort_name = "a_homework_pre_sort";
    if (name == "a_subtextbook") {
      pre_sort_name = "a_subtextbook_pre_sort";
    } else if (name == "a_textbook") {
      pre_sort_name = "a_textbook_pre_sort";
    }
    if (strFunc.is_empty(myProps.daily_info[pre_sort_name])) {
      //select_tag_of_num_style["border"] = "0px"
    }
    select_input_render = (
      <select
        className="select_none_arrow"
        value={myProps.daily_info[pre_sort_name]}
        onChange={(e: any) => {
          myProps.onChange({
            name: pre_sort_name,
            value: e.target.value,
            is_save: true,
          });
        }}
        style={{
          ...select_tag_of_num_style,
          paddingLeft: "0px",
        }} >
        <option value=""></option>
        {name == "a_textbook" &&
          <>
            <option value="개">개</option>
            <option value="심">심</option>
            <option value="유">유</option>
          </>
        }
        {name != "a_textbook" &&
          <>
            <option value="선">선</option>
            <option value="후">후</option>
            <option value="현">현</option>
          </>
        }
      </select>
    );
  }

  let text_input_wrap_style: any = { position: "relative", height: "100%" };
  let text_input_style = { width: "100%", border: "0px", paddingLeft: "1px" };
  if (!strFunc.is_empty(select_input_render)) {
    text_input_wrap_style["paddingLeft"] = "16px";
  }

  let left_btn_render: any = "";
  if (name == "a_textbook") {
    text_input_wrap_style["paddingLeft"] = "24px";
    let left_button_style:any={
      position: "absolute", left: 0, top: -1, padding: "0px 5px", background: "transparent",
      border: "1px solid #555", cursor: "pointer", width: "16px", height: "20px", borderRadius: "0px"
    };
    if(name == "a_subtextbook"){
      text_input_wrap_style["paddingLeft"] = "41px";
      left_button_style["left"]=17;
    }
    
    left_button_style
    left_btn_render = (
      <div className="btn"
        style={left_button_style}
        onClick={() => {
          myProps.onClickLeft({
            name: name,
            value: value,
          });
        }}
      ></div>
    );
  }

  let remove_btn_render: any = "";

  let row_title_str = value;
  let study_use_date_str: any = "";
  let study_use_date_render: any = "";
  let study_use_date_style: any = {
    position: "absolute", right: "0px", top: "0px",
    color: "#777", fontSize: "12px"
  };
  if (name == "a_textbook") {
    if (myProps.daily_info["textbook_use"]) {
      row_title_str += " " + myProps.daily_info["textbook_use"]["a_re_start_date"];
      study_use_date_str = myProps.daily_info["textbook_use"]["a_re_start_date"];
    }
  } else if (name == "a_subtextbook") {
    // if(myProps.daily_info["subtextbook_use"]){
    //   row_title_str+=" "+myProps.daily_info["subtextbook_use"]["a_re_start_date"];
    //   study_use_date_str=myProps.daily_info["subtextbook_use"]["a_re_start_date"];
    // }
  }
  if (study_use_date_str != "") {
    //AttendStateFunc.attend_color_json
    //4,6,8 주
    let now_date_time = new Date().getTime();
    let after_4week_time = DateFunc.get_change_date(new Date(study_use_date_str), 'day', 7 * 4).getTime();
    let after_6week_time = DateFunc.get_change_date(new Date(study_use_date_str), 'day', 7 * 6).getTime();
    let after_8week_time = DateFunc.get_change_date(new Date(study_use_date_str), 'day', 7 * 8).getTime();

    if (name == "a_textbook") {
      if (info["a_stu_grade"] < 14) {
        if (now_date_time >= after_8week_time) {
          text_input_wrap_style["background"] = AttendStateFunc.attend_color_json.absent.background;
        } else if (now_date_time >= after_6week_time) {
          text_input_wrap_style["background"] = AttendStateFunc.attend_color_json.late.background;
        } else if (now_date_time >= after_4week_time) {
          text_input_wrap_style["background"] = AttendStateFunc.attend_color_json.attend.background;
        }
      }
    }

    study_use_date_str = "(" + study_use_date_str.substring(5, 10) + "~)";
    // study_use_date_render = (
    //   <span style={study_use_date_style}>{study_use_date_render}</span>
    // );
  }

  const get_input_tag = () => {
    let input_tag: any = "";
    if (textbook_info != null) {
      if (textbook_info["a_use_sort"] == "coolen") {
        if (name == "a_textbook_study") {
          input_tag = (
            <div>
              {value + "" + myProps.daily_info["a_textbook_study_det"]}
            </div>
          );
          return input_tag;
        }
      }
    }

    input_tag = (
      <input type="text"
        value={value}
        name={name}
        onChange={(e: any) => {
          myProps.onChange({
            name: e.target.name,
            value: e.target.value
          });
        }}
        onClick={(e: any) => {
          myProps.onClick(e);
        }}
        onBlur={(e: any) => {
          myProps.onChange({
            name: e.target.name,
            value: e.target.value,
            is_save: true,
          });
        }}
        title={value + " " + study_use_date_str}
        style={text_input_style}
        autoComplete="off"
        readOnly={myProps.is_print_mode}
      />
    );

    if (myProps.is_check_show_textarea) {
      let tmp_text_area_style: any = {
        ...text_input_style,
        lineHeight: "22px",
        minHeight: "22px",
      };
      if (myProps.is_checked_row) {
        tmp_text_area_style["minHeight"] = "55px";
      }
      input_tag = (
        <TextAreaComponent
          value={value}
          name={name}
          onChange={(e: any) => {
            myProps.onChange({
              name: e.target.name,
              value: e.target.value
            });
          }}
          onClick={(e: any) => {
            myProps.onClick(e);
          }}
          onBlur={(e: any) => {
            let tmp_is_show_loading = false;
            if (e.target.name == "a_memo") {
              tmp_is_show_loading = true;
            }
            myProps.onChange({
              name: e.target.name,
              value: e.target.value,
              is_save: true,
              is_show_loading: tmp_is_show_loading,
            });
          }}
          title={value + " " + study_use_date_str}
          style={tmp_text_area_style}
          height={22}
          is_auto_height={myProps.is_checked_row}
          is_read_only={myProps.is_print_mode}
        ></TextAreaComponent>
      );
    }

    return input_tag;
  };

  return (
    <div style={text_input_wrap_style} title={row_title_str + " " + study_use_date_str}>
      {left_btn_render}
      {select_input_render}
      {get_input_tag()}
      {remove_btn_render}
      {/* <span style={{position:"absolute",top:-5,right:-5,fontSize:11,color:"#444"}}>
        {study_use_date_str}
      </span> */}
    </div>
  );
};
export default DailyInputText;